import { parsePath } from './operators/parsePath';
import { getPath } from './getPath';
export function parse(d) {
    return parsePath(getPath(d));
}
